module.exports = __webpack_public_path__ + "static/mask-5-be854b13a87e6527a9e566dd6e2e1aa8.png";